import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useUser } from '@lib/firebase/provider'
import { PageLoader } from '@components/Loader/PageLoader'
import tenantManager from '@lib/firebase/tenantManager'
import { core, firebaseClientInitConfig } from '@lib/firebase/config'
import { useEffect } from 'react'

const IndexRoute = () => {
  const { isInitialized, user } = useUser()
  const navigate = useNavigate({ from: '/' })

  const isStaff = tenantManager.isCurrentTenant(
    firebaseClientInitConfig.tenantIds.staff
  )

  useEffect(() => {
    if (user && isInitialized) {
      if (isStaff) {
        navigate({ to: core.staffAppPageUrl })
      } else {
        navigate({ to: core.appPageUrl })
      }
    } else if (!user && isInitialized) {
      if (isStaff) {
        navigate({ to: core.staffAuthPageUrl })
      } else {
        navigate({ to: core.authPageUrl })
      }
    }
  }, [user, isInitialized, navigate, isStaff])

  return <PageLoader />
}

export const Route = createFileRoute('/')({
  component: IndexRoute,
})
